import { IsNumber, IsOptional, IsString, ValidateNested } from 'class-validator';
import { Type } from 'class-transformer';

export class CreatorsListDto {
    @IsNumber()
    totalRows!: number;
    @IsNumber()
    userID!: number;
    @IsOptional()
    @IsString()
    firstName!: string;
    @IsOptional()
    @IsString()
    lastName!: string;
    @IsOptional()
    @IsString()
    email!: string;
    @IsOptional()
    @Type(() => CreatorListItem)
    @ValidateNested()
    creators!: CreatorListItem[];
}

export class CreatorListItem {
    @IsNumber()
    projectId!: number;
    @IsString()
    projectCode!: string;
    @IsOptional()
    @IsString()
    projectOwner!: string | null;
    @IsString()
    projectName!: string;
    creatorName!: any;
    @IsString()
    addressLine1!: string;
    @IsString()
    addressLine2!: string;
    @IsString()
    addressLine3!: string;
    @IsString()
    addressLine4!: string;
    @IsString()
    addressNumber!: string;
    @IsString()
    addressPostCode!: string;
    @IsString()
    telephone!: string;
    @IsString()
    ContactType!: string;
    @IsString()
    creatorImage!: string;
}

export class CreatorItem {
    @IsString()
    kontactName!: string;
}
